import { Model } from 'modules/core/lib/mobx-rest'

class Cognito extends Model<{}> {
  static urlRoot() {
    return '/cognito'
  }

  fetchMfaSecretCode(): Promise<MfaSecretCode> {
    return this.rpc('mfa_secret_code') as Promise<MfaSecretCode>
  }
}

/**
 * Raw response body of the GET /cognito/mfa_secret_code endpoint.
 */
export interface MfaSecretCode {
  mfa_secret_code: string
  email: string
}

export default Cognito
